import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';

import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(theme => ({
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
}));

export default function ConfirmEmailDialog(props) {

    const { isOpen, onClose } = props;

    const classes = useStyles();

    return (
        <Dialog
            aria-labelledby="confirm-email-dialog-title"
            open={isOpen}
            aria-describedby="confirm-email-dialogue-description"
            fullWidth
            maxWidth="sm"
            onClose={onClose}
            >
            <DialogTitle id="confirm-email-dialog-title">
                <span>Check your Email Inbox</span>
                <IconButton aria-label="Cancel" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    We've sent an email to your inbox with a link to verify your email address. Sometimes in can take a few minutes to get there, be patient and be sure to check your spam folder just in case.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary" autoFocus>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}
